module.exports = __webpack_public_path__ + "img/20200514_151820.b2ac5431.jpg";